import { CommonAPI } from 'api';
import { CollapsedMarketsType } from 'features/customerPanel/cpPlayerProfile/interface/interface';
import { debounce } from 'lodash';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIsLoggedIn } from 'shared/hooks/useIsLoggedIn';
import { State } from 'shared/interface';
import { createLogger } from 'shared/logger';
import * as actionTypes from 'shared/store/action-types';
import { createAction } from 'shared/util/utility';
import { DSAccordionSettingsType } from '../DSAccordion.types';
import { configDSAccordion, updateAccordtionState } from '../DSAccordion.utils';

export const useDSAccordion = (settings?: DSAccordionSettingsType) => {
	const isLoggedIn = useIsLoggedIn();
	const logger = createLogger('useDSAccordion');
	const dispatch = useDispatch();
	const collapsedMarkets = useSelector<State, any>((state) => state.playerProfile.collapsedMarkets);
	const stateOfCurrentAccordion = settings && collapsedMarkets?.[settings.stateType]?.[settings.stateKey]?.includes(settings.stateValue);
	const debouncedUpdateState = useMemo(
		() =>
			debounce((accordionState: CollapsedMarketsType) => {
				CommonAPI.PlayerProfiles.savePlayersProfile({ collapsedMarkets: accordionState });
			}, configDSAccordion.debounceTime),
		[],
	);

	const toggle = () => {
		if (settings) {
			const accordionsState = updateAccordtionState(collapsedMarkets, settings.stateType, settings.stateKey, settings.stateValue);
			dispatch(createAction(actionTypes.SET_COLLAPSED_MARKET, accordionsState));
			debouncedUpdateState(accordionsState);
			logger.log('Toggled', { state: collapsedMarkets, settings });
		} else {
			logger.error('Wrong accordion configuration', { state: collapsedMarkets, settings });
		}
	};

	useEffect(() => {
		return () => {
			debouncedUpdateState.cancel();
		};
	}, [debouncedUpdateState]);
	return {
		collapsed: settings?.defaultCollapsed ? !stateOfCurrentAccordion : stateOfCurrentAccordion,
		toggle,
		activeManagment: isLoggedIn && !!settings?.stateType,
	};
};
